<template>
  <div>
    <CollapseItems
      title-class-header="h6"
      title-weight-header="bold"
    >
      <template #title>
        <h5 class="font-weight-black">
          Instruções
        </h5>
      </template>
      <template #content>
        <div class="border-bottom p-4 bg-light text-black-50">
          <p class="mb-1 font-weight-bolder">
            Estamos preparando o  {{ selectedCycle.cycle_name }} personalizado para você.
          </p>
          <p class="mb-1">
            <b>PASSO 1</b>
          </p>
          <p class="mb-1">
            Confira o que você vai estudar neste bloco temático
          </p>
        </div>
      </template>
    </CollapseItems>
  </div>
</template>
<script>
import CollapseItems from "@/common/components/CollapseItems.vue";
import { mapGetters } from 'vuex';

export default {
  components: {
    CollapseItems,
  },
  computed: {
    ...mapGetters(['selectedCycle']),
  }
}


</script>
